import { z } from 'zod';

export const HealthResponseSchema = z.object({
  status: z.literal('ok'),
  service: z.string(),
  uptime: z.number(),
  version: z.string(),
});

export type HealthResponse = z.infer<typeof HealthResponseSchema>;
